import { components } from "../utils/alpine";
import AutoUpload from "./AutoUpload.ts";
import ProgressBar from "./ProgressBar.ts";

import SearchBar from "./SearchBar.ts";
import SearchUpload from "./SearchUpload.ts";
import SearchResults from "./SearchResults.ts";
import SearchResult from "./SearchResult.ts";

import ExplorerMode from "./Explorer.ts";
import ExplorerUpload from "./ExplorerUpload.ts";
import LocationBar from "./LocationBar.ts";
import Content from "./Content.ts";
import ContextMenu from "./ContextMenu.ts";
import TreeRoot from "./TreeRoot";
import TreeNode from "./TreeNode";
import RestoreLocationButton from "./RestoreLocationButton.ts";
import NotFoundUpload from "./NotFoundUpload.ts";

import CrossRef from "./CrossRef.ts";
import OfficeStateIndicator from "./OfficeStateIndicator";
import SelectionTest from "./SelectionTests.ts";

components({
  autoUpload: AutoUpload,
  progressBar: ProgressBar,
  officeStateIndicator: OfficeStateIndicator,

  searchBar: SearchBar,
  searchUpload: SearchUpload,
  searchResults: SearchResults,
  searchResult: SearchResult,

  explorerMode: ExplorerMode,
  explorerUpload: ExplorerUpload,
  locationBar: LocationBar,
  content: Content,
  contextMenu: ContextMenu,

  treeRoot: TreeRoot,
  treeNode: TreeNode,

  restoreLocationButton: RestoreLocationButton,

  notFoundUpload: NotFoundUpload,
  crossRef: CrossRef,
  selectionTest: SelectionTest,
});
